const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerAttributes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.995 511.995",
    style: {
      enableBackground: "new 0 0 511.995 511.995"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 255.998,
    cy: 158.413,
    r: 51.342
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 322.535,
    cy: 52.249,
    r: 44.749
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 190.075,
    cy: 52.249,
    r: 44.749
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 123.726,
    cy: 148.61,
    r: 45.57
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M387.352,194.18c-32.147,0.431-58.621,23.584-65.234,53.871c6.495,11.216,10.222,24.213,10.222,38.038v34.473 c0.674,0.101,1.358,0.169,2.059,0.169H442.14c7.671,0,13.889-6.218,13.889-13.888v-44.91 C456.029,224.36,425.035,193.675,387.352,194.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M179.656,287.092c0-14.117,3.798-27.423,10.419-38.896c-6.455-31.028-34.301-54.457-67.267-54.015 c-37.209,0.499-66.841,31.43-66.841,68.642v44.021c0,7.67,6.218,13.888,13.888,13.888h107.741c0.702,0,1.386-0.069,2.06-0.169 V287.092z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M169.296,148.61c0,25.168-20.402,45.57-45.57,45.57c-0.063,0-0.125-0.004-0.189-0.005v0.011 c32.646-0.089,60.131,23.21,66.538,54.008c-0.004,0.007-0.007,0.013-0.011,0.02c13.041-22.612,37.085-38.087,64.899-38.46 c0.338-0.005,0.675,0,1.012-0.001c-28.345-0.012-51.32-22.993-51.32-51.341c0-19.996,11.439-37.31,28.123-45.788 c-11.793-9.918-27.034-15.851-43.605-15.628c-14.974,0.201-28.694,5.427-39.678,14.033 C161.452,119.244,169.296,133.009,169.296,148.61z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M307.34,158.413c0,28.348-22.974,51.329-51.319,51.341c28.158,0.009,52.88,15.463,66.105,38.311 c-0.003-0.005-0.005-0.01-0.008-0.014c6.613-30.287,33.087-53.44,65.234-53.871c0.577-0.008,1.148,0.014,1.722,0.021v-0.042 c-0.268,0.005-0.534,0.02-0.804,0.02c-25.168,0-45.57-20.402-45.57-45.57c0-15.778,8.02-29.68,20.204-37.86 c-11.44-8.783-25.773-13.961-41.27-13.753c-16.017,0.215-30.602,6.173-41.936,15.875 C296.121,121.437,307.34,138.61,307.34,158.413z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M309.037,448.045c6.554-6.388,2.938-17.519-6.12-18.835l-19.833-2.882c-3.597-0.523-6.706-2.781-8.314-6.04l-8.87-17.972 c-4.051-8.207-15.754-8.207-19.804,0l-8.87,17.972c-1.609,3.259-4.718,5.518-8.315,6.04l-19.834,2.882 c-9.057,1.316-12.673,12.447-6.12,18.835l14.352,13.989c2.603,2.537,3.79,6.192,3.176,9.774l-3.388,19.753 c-1.547,9.021,7.921,15.9,16.022,11.641l17.739-9.326c3.217-1.691,7.06-1.691,10.277,0l17.739,9.326 c8.101,4.259,17.57-2.62,16.022-11.641l-3.388-19.753c-0.615-3.582,0.573-7.237,3.176-9.774L309.037,448.045z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M415.989,420.276c4.835-4.713,2.167-12.924-4.515-13.895l-14.631-2.126c-2.653-0.386-4.947-2.052-6.133-4.456l-6.543-13.258 c-2.988-6.055-11.622-6.055-14.61,0l-6.543,13.258c-1.187,2.404-3.48,4.07-6.134,4.456l-14.631,2.126 c-6.681,0.971-9.349,9.182-4.515,13.895l10.587,10.32c1.92,1.872,2.796,4.568,2.343,7.21l-2.499,14.572 c-1.141,6.655,5.843,11.729,11.819,8.587l13.086-6.88c2.373-1.248,5.208-1.248,7.581,0l13.086,6.88 c5.976,3.142,12.961-1.933,11.82-8.587l-2.499-14.572c-0.453-2.643,0.423-5.339,2.343-7.21L415.989,420.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M502.445,379.602c4.014-3.913,1.799-10.73-3.748-11.537l-12.148-1.765c-2.203-0.32-4.108-1.704-5.093-3.7l-5.433-11.008 c-2.481-5.027-9.65-5.027-12.13,0L458.46,362.6c-0.985,1.996-2.89,3.38-5.093,3.7l-12.148,1.765 c-5.548,0.806-7.763,7.624-3.748,11.537l8.791,8.569c1.594,1.554,2.322,3.793,1.945,5.987l-2.075,12.099 c-0.948,5.525,4.852,9.739,9.814,7.13l10.866-5.712c1.971-1.036,4.324-1.036,6.295,0l10.866,5.712 c4.962,2.609,10.762-1.605,9.814-7.13l-2.075-12.099c-0.376-2.194,0.351-4.433,1.945-5.987L502.445,379.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M96.006,420.276c-4.835-4.713-2.167-12.924,4.515-13.895l14.631-2.126c2.653-0.386,4.947-2.052,6.133-4.456l6.543-13.258 c2.988-6.055,11.622-6.055,14.61,0l6.543,13.258c1.187,2.404,3.48,4.07,6.134,4.456l14.631,2.126 c6.681,0.971,9.349,9.182,4.515,13.895l-10.587,10.32c-1.92,1.872-2.796,4.568-2.343,7.21l2.499,14.572 c1.141,6.655-5.843,11.729-11.82,8.587l-13.086-6.88c-2.373-1.248-5.208-1.248-7.581,0l-13.086,6.88 c-5.976,3.142-12.961-1.933-11.82-8.587l2.499-14.572c0.453-2.643-0.423-5.339-2.343-7.21L96.006,420.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M9.55,379.602c-4.014-3.913-1.799-10.73,3.748-11.537l12.148-1.765c2.203-0.32,4.108-1.704,5.093-3.7l5.433-11.008 c2.481-5.027,9.65-5.027,12.13,0l5.433,11.008c0.985,1.996,2.89,3.38,5.093,3.7l12.148,1.765c5.548,0.806,7.763,7.624,3.748,11.537 l-8.791,8.569c-1.594,1.554-2.322,3.793-1.945,5.987l2.075,12.099c0.948,5.525-4.852,9.739-9.814,7.13l-10.866-5.712 c-1.971-1.036-4.324-1.036-6.295,0l-10.866,5.712c-4.962,2.609-10.762-1.605-9.814-7.13l2.075-12.099 c0.376-2.194-0.351-4.433-1.945-5.987L9.55,379.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M273.498,352.336h43.194c8.642,0,15.648-7.006,15.648-15.648V286.09c0-42.332-34.919-76.904-77.376-76.335 c-41.922,0.563-75.308,35.411-75.308,77.336v49.596c0,8.642,7.006,15.648,15.648,15.648h43.194"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M430.736,132.084c-6.619-16.995-23.131-29.044-42.467-29.044c-25.168,0-45.57,20.402-45.57,45.57s20.402,45.57,45.57,45.57 c18.589,0,34.567-11.136,41.656-27.096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerAttributes);
export default __webpack_public_path__ + "static/media/customer-attributes.1542f7bf0e22f1fef72e3daacd58d304.svg";
export { ForwardRef as ReactComponent };